import { Injectable } from '@angular/core';
import { ActivityStudent, ActivityStudentAnswers } from '@tekman/onmat/models';
import { Subject } from 'rxjs';

@Injectable()
export class StatementEventsService {
  private subjectSend = new Subject<boolean>();
  public sendActivity$ = this.subjectSend.asObservable();
  private subjectSave = new Subject<boolean>();
  public saveActivity$ = this.subjectSave.asObservable();
  private subjectSaveInputs = new Subject<ActivityStudent>();
  public saveInputs$ = this.subjectSaveInputs.asObservable();
  private subjectSendInputs = new Subject<ActivityStudent>();
  public sendInputs$ = this.subjectSendInputs.asObservable();
  private inputChange = new Subject<ActivityStudentAnswers>();
  public inputChange$ = this.inputChange.asObservable();

  emitSend(value: boolean): void {
    this.subjectSend.next(value);
  }

  emitSave(value: boolean): void {
    this.subjectSave.next(value);
  }

  emitSaveInputs(studentAnswers: ActivityStudent): void {
    this.subjectSaveInputs.next(studentAnswers);
  }

  emitSendInputs(studentAnswers: ActivityStudent): void {
    this.subjectSendInputs.next(studentAnswers);
  }

  emitInputChange(activityStudentAnswers: ActivityStudentAnswers): void {
    this.inputChange.next(activityStudentAnswers);
  }
}
